import React from "react";
import { get } from "lodash";
import { PREPAYMENT_TYPES, AGGREGATE_INTEREST_METHODS } from "@loanbossinc/component-library";

import { StyledGridContainer, StyledLinkContainer, StyledLinkContainerRight, StyledFormikInputNumber, StyledFormikInputMoney, StyledFormikInputPercent, StyledFormikInputTypeAhead, StyledLinkText, StyledLinkTextFloatRight, StyledPrepaymentScheduleContainer, StyledPrepaymentScheduleContainerFooter } from "./section.styles";

export const addScheduleRow = (quoteData, setValues) => {
  const prepaymentSchedules = quoteData.prepaymentSchedules;
  prepaymentSchedules.push({ prepaymentTypeId: null });
  setValues({
    ...quoteData,
    prepaymentSchedules
  });
};
export const setInitialPrepaymentSchedule = (quoteData, value, setValues) => {
  const prepaymentSchedules = quoteData.prepaymentSchedules;
  if (prepaymentSchedules && prepaymentSchedules.length > 0) {
    return null;
  }
  prepaymentSchedules.push({ prepaymentTypeId: value });
  setValues({
    ...quoteData,
    prepaymentSchedules,
    prepaymentTerms: {
      prepaymentTypeId: value
    }
  });
};
export const getNoneRow = (index, prepaymentTypes, values, setValues) => (<>
  <StyledPrepaymentScheduleContainer container>
    <StyledGridContainer item xs={6}>
      <StyledFormikInputTypeAhead
        id="prepaymentScheduleTypeId"
        name={`prepaymentSchedules[${index}].prepaymentTypeId`}
        label="Prepayment Type"
        options={prepaymentTypes}
        displayWith={option => option && option.name}
        setValueWith={option => option && option.id}
        onChange={value => { }}
        className="input"
        variant={"filled"}
      />
    </StyledGridContainer>
  </StyledPrepaymentScheduleContainer>
  {getFooter(values, index, setValues)}
</>
);
export const getBasicRow = (index, prepaymentTypes, values, setValues) => {
  const prepaymentSchedules = values.prepaymentSchedules;

  return (<>
    <StyledPrepaymentScheduleContainer container>
      <StyledGridContainer item xs={6}>
        <StyledFormikInputTypeAhead
          id="prepaymentScheduleTypeId"
          name={`prepaymentSchedules[${index}].prepaymentTypeId`}
          label="Prepayment Type"
          options={prepaymentTypes}
          displayWith={option => option && option.name}
          setValueWith={option => option && option.id}
          onChange={value => { }}
          className="input"
          variant={"filled"}
        />
      </StyledGridContainer>
      <StyledGridContainer item xs={1} />
      <StyledGridContainer item xs={5}>
        <StyledFormikInputNumber
          name={`prepaymentSchedules[${index}].term`}
          label={"Term (months)"}
          variant={"filled"}
        />
      </StyledGridContainer>
      {prepaymentSchedules[index].isVisible && <>
        <StyledGridContainer item xs={6}>
          <StyledFormikInputPercent
            name={`prepaymentSchedules[${index}].percent`}
            label={"Minimum Prepayment (%)"}
            decimals={3}
            variant={"filled"}
          />
        </StyledGridContainer>
        <StyledGridContainer item xs={1} />
        <StyledGridContainer item xs={5}>
          <StyledFormikInputNumber
            name={`prepaymentSchedules[${index}].openPeriod`}
            label={"Open Periods (months)"}
            variant={"filled"}
          />
        </StyledGridContainer>

        <StyledGridContainer item xs={12}>
          <StyledFormikInputPercent
            name={`prepaymentSchedules[${index}].replacementRateSpread`}
            label={"Replacement Rate Spread (bps)"}
            decimals={3}
            variant={"filled"}
          />
        </StyledGridContainer>
      </>}
    </StyledPrepaymentScheduleContainer>
    {getFooter(values, index, setValues)}
          </>
  );
};
export const getLockoutRow = (index, prepaymentTypes, values, setValues) => (<>
  <StyledPrepaymentScheduleContainer container>
    <StyledGridContainer item xs={6}>
      <StyledFormikInputTypeAhead
        id="prepaymentScheduleTypeId"
        name={`prepaymentSchedules[${index}].prepaymentTypeId`}
        label="Prepayment Type"
        options={prepaymentTypes}
        displayWith={option => option && option.name}
        setValueWith={option => option && option.id}
        onChange={value => { }}
        className="input"
        variant={"filled"}
      />
    </StyledGridContainer>
    <StyledGridContainer item xs={1} />
    <StyledGridContainer item xs={5}>
      <StyledFormikInputNumber
        name={`prepaymentSchedules[${index}].term`}
        label={"Term (months)"}
        variant={"filled"}
      />
    </StyledGridContainer>
  </StyledPrepaymentScheduleContainer>
  {getFooter(values, index, setValues)}
</>
);
export const getFlatPercentageRow = (index, prepaymentTypes, values, setValues) => {
  const prepaymentSchedules = values.prepaymentSchedules;

  return (<>
    <StyledPrepaymentScheduleContainer container>
      <StyledGridContainer item xs={6}>
        <StyledFormikInputTypeAhead
          id="prepaymentScheduleTypeId"
          name={`prepaymentSchedules[${index}].prepaymentTypeId`}
          label="Prepayment Type"
          options={prepaymentTypes}
          displayWith={option => option && option.name}
          setValueWith={option => option && option.id}
          onChange={value => { }}
          className="input"
          variant={"filled"}
        />
      </StyledGridContainer>
      <StyledGridContainer item xs={1} />
      <StyledGridContainer item xs={5}>
        <StyledFormikInputNumber
          name={`prepaymentSchedules[${index}].term`}
          label={"Term (months)"}
          variant={"filled"}
        />
      </StyledGridContainer>

      {prepaymentSchedules[index].isVisible && <StyledGridContainer item xs={12}>
        <StyledFormikInputPercent
          name={`prepaymentSchedules[${index}].percent`}
          label={"Minimum Prepayment (%)"}
          decimals={3}
          variant={"filled"}
        />
                                               </StyledGridContainer>}
    </StyledPrepaymentScheduleContainer>
    {getFooter(values, index, setValues)}
          </>
  );
};
export const getTermOpenPeriodRow = (index, prepaymentTypes, values, setValues) => {
  const prepaymentSchedules = values.prepaymentSchedules;

  return (<>
    <StyledPrepaymentScheduleContainer container>
      <StyledGridContainer item xs={6}>
        <StyledFormikInputTypeAhead
          id="prepaymentScheduleTypeId"
          name={`prepaymentSchedules[${index}].prepaymentTypeId`}
          label="Prepayment Type"
          options={prepaymentTypes}
          displayWith={option => option && option.name}
          setValueWith={option => option && option.id}
          onChange={value => { }}
          className="input"
          variant={"filled"}
        />
      </StyledGridContainer>
      <StyledGridContainer item xs={1} />
      <StyledGridContainer item xs={5}>
        <StyledFormikInputNumber
          name={`prepaymentSchedules[${index}].term`}
          label={"Term (months)"}
          variant={"filled"}
        />
      </StyledGridContainer>

      {prepaymentSchedules[index].isVisible && <StyledGridContainer item xs={6}>
        <StyledFormikInputNumber
          name={`prepaymentSchedules[${index}].openPeriod`}
          label={"Open Periods (months)"}
          variant={"filled"}
        />
                                               </StyledGridContainer>}
    </StyledPrepaymentScheduleContainer>
    {getFooter(values, index, setValues)}
          </>
  );
};
export const getAggregateInterestRow = (index, prepaymentTypes, values, setValues) => {
  const prepaymentSchedules = values.prepaymentSchedules;
  const aggregateInterestMethodId = get(values, `prepaymentSchedules[${index}].aggregateInterestMethodId`);
  const showPrepaymentAmt = aggregateInterestMethodId === AGGREGATE_INTEREST_METHODS.DEFINED;
  const showPrepaymentMonths = aggregateInterestMethodId === AGGREGATE_INTEREST_METHODS.FORMULAIC;

  return (<>
    <StyledPrepaymentScheduleContainer container>
      <StyledGridContainer item xs={6}>
        <StyledFormikInputTypeAhead
          id="prepaymentScheduleTypeId"
          name={`prepaymentSchedules[${index}].prepaymentTypeId`}
          label="Prepayment Type"
          options={prepaymentTypes}
          displayWith={option => option && option.name}
          setValueWith={option => option && option.id}
          onChange={value => { }}
          className="input"
          variant={"filled"}
        />
      </StyledGridContainer>
      <StyledGridContainer item xs={1} />
      <StyledGridContainer item xs={5}>
        <StyledFormikInputNumber
          name={`prepaymentSchedules[${index}].term`}
          label={"Term (months)"}
          variant={"filled"}
        />
      </StyledGridContainer>

      {prepaymentSchedules[index].isVisible && <>
        <StyledGridContainer item xs={6}>
          <StyledFormikInputTypeAhead
            id="prepaymentScheduleTypeId"
            name={`prepaymentSchedules[${index}].aggregateInterestMethodId`}
            label="Defined/Formulaic"
            options={[
              { "id": AGGREGATE_INTEREST_METHODS.DEFINED, "name": "Defined" },
              { "id": AGGREGATE_INTEREST_METHODS.FORMULAIC, "name": "Formulaic" }
            ]}
            displayWith={option => option && option.name}
            setValueWith={option => option && option.id}
            onChange={value => { }}
            className="input"
            variant={"filled"}
          />
        </StyledGridContainer>
        <StyledGridContainer item xs={1} />
        <StyledGridContainer item xs={5}>
          {showPrepaymentAmt && <StyledFormikInputMoney
            name={`prepaymentSchedules[${index}].aggregateInterestDefinedAmt`}
            label={"Prepayment Amount ($)"}
            variant={"filled"}
          />}
          {showPrepaymentMonths && <StyledFormikInputNumber
            name={`prepaymentSchedules[${index}].aggregateInterestMonthsOfInterest`}
            label={"Months"}
            variant={"filled"}
          />}
        </StyledGridContainer>
      </>}
    </StyledPrepaymentScheduleContainer>
    {getFooter(values, index, setValues)}
          </>
  );
};
export const getFooter = (values, index, setValues) => {
  const isVisible = values.prepaymentSchedules[index].isVisible;

  return (<StyledPrepaymentScheduleContainerFooter container>
    <StyledLinkContainer item xs={5}>
      <StyledLinkText
        onClick={() => {
          openCloseDetails(values, index, setValues);
        }}
      >
        {`${isVisible ? "Hide" : "Show"} Details`}
      </StyledLinkText>
    </StyledLinkContainer>
    <StyledLinkContainerRight item xs={5}>
      <StyledLinkTextFloatRight
        onClick={() => {
          deleteSchedule(values, index, setValues);
        }}
      >
        Delete Row
      </StyledLinkTextFloatRight>
    </StyledLinkContainerRight>
          </StyledPrepaymentScheduleContainerFooter>);
};
export const openCloseDetails = (values, index, setValues) => {
  const prepaymentSchedules = values.prepaymentSchedules;
  prepaymentSchedules[index].isVisible = !prepaymentSchedules[index].isVisible;
  setValues({
    ...values,
    prepaymentSchedules
  });
};
export const deleteSchedule = (values, index, setValues) => {
  const prepaymentSchedules = values.prepaymentSchedules;
  prepaymentSchedules.splice(index, 1);
  setValues({
    ...values,
    prepaymentSchedules
  });
};
export const renderPrepaymentSchedules = (values, setValues) => {
  if (!values || !values.prepaymentSchedules || values.prepaymentSchedules.length === 0) {
    return null;
  }

  const prepaymentTypes = values && values.ancillary && values.ancillary.prepaymentTypes ? values.ancillary.prepaymentTypes : [];

  return values.prepaymentSchedules.map((item, index) => {
    switch (values.prepaymentSchedules[index].prepaymentTypeId) {
      case PREPAYMENT_TYPES.YIELD_MAINTENANCE:
      case PREPAYMENT_TYPES.YIELD_MAINTENANCE_AGENCY:
      case PREPAYMENT_TYPES.MAKE_WHOLE:
        return getBasicRow(index, prepaymentTypes, values, setValues);
      case PREPAYMENT_TYPES.LOCKOUT:
        return getLockoutRow(index, prepaymentTypes, values, setValues);
      case PREPAYMENT_TYPES.FLAT_PERCENTAGE:
        return getFlatPercentageRow(index, prepaymentTypes, values, setValues);
      case PREPAYMENT_TYPES.DEFEASANCE:
      case PREPAYMENT_TYPES.SPREAD_MAINTENANCE:
        return getTermOpenPeriodRow(index, prepaymentTypes, values, setValues);
      case PREPAYMENT_TYPES.AGGREGATE_INTEREST:
        return getAggregateInterestRow(index, prepaymentTypes, values, setValues);
      case PREPAYMENT_TYPES.NONE:
      default:
        return getNoneRow(index, prepaymentTypes, values, setValues);
    }
  });
};
